<template>
    <div style="height: 100%; background-color: rgb(238 238 238)">
        <v-container class="align-center">
            <v-row class="justify-center">
                <div class="d-flex align-center">
                    <v-card-title style="font-size: 24px; color: black">{{ announcementsTabName }}</v-card-title>
                    <v-icon v-if="twitterId" @click="navigateTo('/twitter')" class="pa-4">mdi-twitter</v-icon>
                    <v-icon v-if="facebookId" @click="navigateTo('/facebook')" class="pa-4">mdi-facebook</v-icon>
                </div>
            </v-row>
            <v-row justify="center" class="pa-2">
                <v-card elevation="0" style="background-color: rgb(238 238 238); width: 100%" class="ml-n12">
                    <v-timeline dense class="pt-1">
                        <v-timeline-item
                                v-for="(announcement, index) in announcements"
                                :key="index"
                                :color="'primary'"
                                style="margin-left: -30px"
                                hide-dot
                        >
                            <v-card>
                                <v-card-title class="text-h6">
                                    <template>
                                        {{ announcement.title }}
                                    </template>
                                </v-card-title>
                                <v-card-text class="text-body-1">
                                    <span v-html="formatBody(announcement.body)"></span>
                                </v-card-text>

                                <div class="ml-4 pb-2 d-flex align-center text-caption grey--text">
                                    <span>{{ formatDateTime(announcement.created) }}</span>
                                    <span class="ml-1" v-if="announcement.updated">({{ $t('messages.edited').toLowerCase() }})</span>
                                </div>

                            </v-card>
                        </v-timeline-item>
                    </v-timeline>
                </v-card>
            </v-row>
        </v-container>
    </div>

</template>

<script>

import Common from "@/mixins/Common.vue";

export default {
    name: 'AnnouncementFeed',
    components: {},
    mixins: [Common],
    data() {
        return {
            announcements: []
        };
    },
    methods: {
        navigateTo(route) {
            this.$router.push(route);
        },

        formatBody(body) {
            return body.replace(/\n/g, '<br>');
        },

        loadAnnouncements() {
            if (!this.netownerId || !this.idToken) {
                return;
            }
            let url = `${this.apiUrl}customer/netowner/${this.netownerId}/announcement`;
            this.$http.get(url)
                    .then((response) => {
                        this.announcements = response.body
                    }, response => {
                        console.error(response)
                    });
        },
    },

    watch: {
        '$route.fullPath'(newPath) {
            if (newPath.includes('announcements')) {
                this.loadAnnouncements();
            }
        },
    },
    mounted() {
        this.loadAnnouncements()
    },

};
</script>

<style scoped>
.text-caption {
    color: rgba(0, 0, 0, 0.6);
}
</style>
